import Header from "./Componets/Header";

import { Routes, Route, useLocation } from "react-router-dom";

import { useTranslation } from "react-i18next";
import { useEffect } from "react";

import AOS from "aos";
import "aos/dist/aos.css"

import Home from "./pages/Home";
import About from "./pages/About";
import Skills from "./pages/Skills";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";

import NotFound from "./Componets/NotFound";

import { Helmet } from "react-helmet-async";

function App() {

  const { t, i18n } = useTranslation();

  const location = useLocation();

  const currentUrl = `https://mohamedeltohamy.com${location.pathname}`;

  useEffect(() => {
  AOS.init({
    duration: 800,
    once: true,
  });
  }, []);

  useEffect(() => {
  const timer = setTimeout(() => {
    const splash = document.getElementById("splash");

    if (splash) {
      splash.classList.add("hide");

      setTimeout(() => {
        splash.remove();
      }, 700); 
    }
  }, 2000);

  return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
  if (location.pathname.startsWith("/ar")) {
    i18n.changeLanguage("ar");
    document.documentElement.lang = "ar";
    
  } else {
    i18n.changeLanguage("en");
    document.documentElement.lang = "en";
    document.documentElement.dir = "ltr";
  }
  }, [location.pathname, i18n]);


  const pageTitles = {
    "/": {
      en: "Mohamed Eltohamy | Front-End Developer",
      ar: "محمد التهامي | مطور مواقع الويب",
    },

    "/about": {
      en: "Mohamed Eltohamy | About",
      ar: "محمد التهامي | نبذة عني",
    },

    "/skills": {
      en: "Mohamed Eltohamy | Skills",
      ar: "محمد التهامي | المهارات",
    },

    "/projects": {
      en: "Mohamed Eltohamy | Projects",
      ar: "محمد التهامي | المشاريع",
    },

    "/contact": {
      en: "Mohamed Eltohamy | Contact",
      ar: "محمد التهامي | تواصل معي",
    },
  };

  const pagePath = location.pathname.replace(/^\/ar/, "") || "/";

  const pageTitle =
    pageTitles[pagePath]?.[i18n.language] ||
    "Mohamed Eltohamy | Web Developer";


  return (
    <>
      
      <Helmet>
        <html lang={i18n.language} />

        <title>{pageTitle}</title>

        <meta name="description" content={t("meta.description")} />

        <link rel="canonical" href={currentUrl} />
        
        <link rel="alternate" hrefLang="en" href={`https://mohamedeltohamy.com${location.pathname.replace(/^\/ar/, "")}`}/>

        <link rel="alternate" hrefLang="ar" href={`https://mohamedeltohamy.com/ar${location.pathname.replace(/^\/ar/, "")}`} />
        
        <link rel="alternate" hrefLang="x-default" href="https://mohamedeltohamy.com/" />
        
        <meta property="og:title" content={pageTitle} />

        <meta
          property="og:description"
          content={t("meta.description")}
        />

        <meta property="og:url" content={currentUrl} />

        <meta property="og:type" content="website" />

        <meta
          property="og:image"
          content="https://mohamedeltohamy.com/Profile-photo.PNG"
        />
          
        <meta name="twitter:title" content={pageTitle} />

        <meta
          name="twitter:description"
          content={t("meta.description")}
        />

        <meta
          name="twitter:image"
          content="https://mohamedeltohamy.com/Profile-photo.PNG"
        />

        <meta
          name="twitter:card"
          content="summary_large_image"
        />

      </Helmet>

      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/skills" element={<Skills />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/contact" element={<Contact />} />

        <Route path="/ar" element={<Home />} />
        <Route path="/ar/about" element={<About />} />
        <Route path="/ar/skills" element={<Skills />} />
        <Route path="/ar/projects" element={<Projects />} />
        <Route path="/ar/contact" element={<Contact />} />

        <Route path="*" element={<NotFound/>} />
      </Routes>
    </>
  );
}

export default App;